<div style="width: 70%; min-width: 300px; margin: auto">
  <div style="text-align: center;">
    <app-loading-swirly [isLoading]="isLoading"></app-loading-swirly>
  </div>

  @if (!isLoading && (!quote || !neighborPermission)) {
    <div>
      Could not find the requested quote. Please contact your account manager or call {{contactPhoneNumber}} for assistance.
    </div>
  }
  @if (quote && neighborPermission) {
    <div>
      <div class="bold">Work Address:</div>
      <p>
        {{quote.address.street}}, {{quote.address.city}}, {{quote.address.state.abbreviation}} {{quote.address.zip}}
      </p>
      <div class="bold">Projected Date of Work Completion:</div>
      @if (quote.workOrderWellnessTasks?.length > 0 && quote.workOrderWorkTasks?.length == 0) {
        <div><!-- Only has wellness tasks -->
          <p>
            Tree Wellness services will be performed at the most optimal time to apply treatment (based on the Growing Degree Day calendar). You will be notified 1-2 days prior to service(s) being performed. Contact us for a more specific timing of your services.
          </p>
        </div>
      }
      @if (!(quote.workOrderWellnessTasks?.length > 0 && quote.workOrderWorkTasks?.length == 0)) {
        <span> <!-- Has work tasks (can also have wellness tasks) -->
          @if (quote.priorityTypeShortcut?.weeksOutStart != undefined && quote.completionStatus != 'Work Orders Created') {
            <div>
              <p>
                {{quote.priorityTypeShortcut.weeksOutStart}} to {{quote.priorityTypeShortcut.weeksOutEnd}} weeks out<br/>
              </p>
            </div>
          }
          @if (quote.priorityTypeShortcut?.weeksOutStart == undefined || quote.completionStatus == 'Work Orders Created') {
            <div>
              @if (quote.dueDateStart && quote.dueDateEnd) {
                <p>
                  Between {{quote.dueDateStart | date: 'shortDate'}} and {{quote.dueDateEnd | date: 'shortDate'}}
                </p>
              }
              @if (quote.dueDateStart && !quote.dueDateEnd) {
                <p>
                  After {{quote.dueDateStart | date: 'shortDate'}}
                </p>
              }
              @if (!quote.dueDateStart && quote.dueDateEnd) {
                <p>
                  Before {{quote.dueDateEnd | date: 'shortDate'}}
                </p>
              }
            </div>
          }
        </span>
      }
      @if (quote.neighborPermissionRequired) {
        <div class="green-box">
          <div>
            <div class="bold">Neighbor's Permission <span style="text-decoration: underline;">Required:</span></div>
            <p>
              To complete tree work for {{quote.customer.fullName}}, our crew requires the ability to access the neighboring property at <span class="bold">{{neighborPermission.address}}</span>.
            </p>
            <p class="bold">For the Owner of <span style="text-decoration: underline;">{{neighborPermission.address}}:</span></p>
            <p>
              By signing below [1] I acknowledge I am the owner of the property of  <span class="bold">{{neighborPermission.address}};</span> [2] I grant Russell Tree Experts ltd. (RTE) permission
              to access my property while they complete tree work for <span class="bold">{{quote.customer.fullName}};</span> [3] I acknowledge RTE warrants that all operations will
              follow the ANSI Z 133.1 Industry safety standard; [4] For everyone's safety, I agree not to enter the work area during tree work operations.
            </p>
            <p>
              Description of activities to be performed: <span class="bold">{{neighborPermission.activitiesOnNeighborProperty}}</span>
              <br/>
              Please call {{quote.representative.fullName}} at {{quote.representative.phoneNumber | phoneNumber}} with any questions.
            </p>
          </div>
          <div class="p-grid ui-fluid">
            <div class="p-col-12 p-md-6">
              <div>First Name</div>
              <input
                pInputText
                name="neighborFirstName"
                [(ngModel)]="neighborPermission.firstName"
                style="border-radius: 5px;"
                minlength="1"
                (blur)="onNeighborInfoUpdate()"
                [disabled]="quote.completionStatus === 'Work Orders Created'"
                [required]="neighborPermissionRequired" />
              </div>
              <div class="p-col-12 p-md-6">
                <div>Last Name</div>
                <input
                  pInputText
                  name="neighborLastName"
                  minlength="1"
                  [(ngModel)]="neighborPermission.lastName"
                  style="border-radius: 5px;"
                  (blur)="onNeighborInfoUpdate()"
                  [disabled]="quote.completionStatus === 'Work Orders Created'"
                  [required]="neighborPermissionRequired" />
                </div>
                <div class="p-col-12 p-md-9">
                  <div>Email Address</div>
                  <input
                    #emailInput="ngModel"
                    pInputText
                    name="neighborLastEmail"
                    email
                    [(ngModel)]="neighborPermission.email"
                    style="border-radius: 5px;"
                    (blur)="onNeighborInfoUpdate()"
                    [disabled]="quote.completionStatus === 'Work Orders Created'"
                    [required]="neighborPermissionRequired" />
                  </div>
                  <div class="p-col-12 p-md-3">
                    <div>Receive Marketing Emails? <i class="pi pi-info-circle" style="vertical-align: middle;" pTooltip="You will receive a confirmation email upon signing but if you want to be included on future RTE marketing emails, check the box below!"></i></div>
                    <p-checkbox
                      binary="true"
                      name="showInactive"
                      [disabled]="quote.completionStatus === 'Work Orders Created'"
                      [(ngModel)]="neighborPermission.signUpForEmails">
                    </p-checkbox>
                  </div>
                  <div class="p-col-12">
                    <app-signature-area
                      [signature]="neighborPermission.neighborSignature"
                      [isAlwaysDisabled]="quote.completionStatus === 'Work Orders Created'"
                      [name]="'Neighbor\'s'"
                      (currentSignature)="onUpdatedNeighborSignature($event)"
                      >
                    </app-signature-area>
                  </div>
                </div>
                <div style="text-align: right;">
                  <p-button
                    
                    label="Save"
                    (click)="save()"
                    style="border-radius: 5px;"
          [disabled]="neighborPermissionRequired && (!neighborPermission.neighborSignature 
                      || !neighborPermission.email
                      || emailInput.invalid
                      || !neighborPermission.firstName
                      || !neighborPermission.firstName
                      || !neighborPermission.email?.trim() 
                      || !neighborPermission.firstName?.trim() 
                      || !neighborPermission.lastName?.trim())"        
                  ></p-button>
                </div>
              </div>
            }
          </div>
        }
      </div>